// PROPOSITO: todo lo compartido del lado de la alumna. No conoce ninguna pantalla concreta.
// DEPENDENCIAS: react-router-dom, BarraDeSincronizacion, Avisos.
// NO OBVIO (1): la barra inferior vive AQUI, no en las pantallas. Si viviera en una pantalla,
// desapareceria al navegar — que es exactamente el sintoma de tenerla en el sitio equivocado.
// NO OBVIO (2): el hueco de abajo es mas grande de lo que mide la barra. La barra FLOTA separada
// del borde, asi que necesita su alto MAS su separacion MAS el area segura del telefono; si no, la
// ultima fila de cualquier lista queda debajo y no se puede tocar.

import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { BarraDeSincronizacion } from '@/components/BarraDeSincronizacion'
import { Avisos } from '@/components/Avisos'
import { BarraDeNavegacion } from '@/components/BarraDeNavegacion'


export function AlumnaLayout() {
  return (
    <div className="min-h-screen bg-superficie-baja pb-[calc(6rem+env(safe-area-inset-bottom))]">
      <BarraDeSincronizacion />

      <main className="mx-auto w-full max-w-lg px-4 py-4">
        <Suspense fallback={<div className="py-12 text-center text-sobre-tenue">Cargando…</div>}>
          <Outlet />
        </Suspense>
      </main>

      <BarraDeNavegacion />

      <Avisos />
    </div>
  )
}
